document.addEventListener('DOMContentLoaded', () => {
  const tabLinks = Array.from(document.querySelectorAll('#portfolioTabs .nav-link'));
  const tabPanes = Array.from(document.querySelectorAll('#portfolioTabsContent .tab-pane'));

  function switchTab(targetIndex) {
    const currentLink = tabLinks.find(t => t.classList.contains('active'));
    const targetLink  = tabLinks[targetIndex];
    if (!targetLink || targetLink === currentLink) return;

    const currentPane = tabPanes.find(p => p.classList.contains('active'));
    const targetId    = targetLink.getAttribute('data-bs-target').replace('#', '');
    const targetPane  = document.getElementById(targetId);
    if (!targetPane) return;

    // Update aria / tab state
    tabLinks.forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    targetLink.classList.add('active');
    targetLink.setAttribute('aria-selected', 'true');

    // Crossfade: keep current visible, fade in target on top
    if (currentPane) {
      currentPane.classList.remove('active');  // goes to position:absolute, opacity:0
    }
    targetPane.classList.add('show', 'active');
  }

  document.addEventListener('click', e => {
    const nextBtn = e.target.closest('.next-item');
    const prevBtn = e.target.closest('.prev-item');
    if (!nextBtn && !prevBtn) return;

    const activeIndex = tabLinks.findIndex(t => t.classList.contains('active'));
    if (nextBtn) switchTab((activeIndex + 1) % tabLinks.length);
    else         switchTab((activeIndex - 1 + tabLinks.length) % tabLinks.length);
  });

  // Override Bootstrap tab clicks to use crossfade too
  tabLinks.forEach((link, i) => {
    link.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      switchTab(i);
    });
  });
});
